import { AxiosPromise } from 'axios'
import { createTeamClient } from './createTeamClient'
import { updateSubscription, getTeam, getSubscription, getInvoices, postSubscription, updateTeam } from './methods'
import { TeamClient as BaseTeamClient, TeamClientOptions } from './types'

export default function TeamClient(options?: TeamClientOptions): TeamClient {
  const commonOptions = {}

  return createTeamClient({
    ...commonOptions,
    ...options,
    methods: {
      updateTeam,
      getSubscription,
      updateSubscription,
      postSubscription,
      getInvoices,
      getTeam,
    },
  })
}

export type TeamClient = BaseTeamClient & {
  readonly updateTeam: (data: any) => AxiosPromise<any>
  readonly updateSubscription: (data: any) => AxiosPromise<any>
  readonly getSubscription: () => AxiosPromise<any>
  readonly postSubscription: (data: any) => AxiosPromise<any>
  readonly getInvoices: () => AxiosPromise<any>
  readonly getTeam: () => AxiosPromise<any>
}
